import { useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { ArrowRight, Check } from "lucide-react";

const FORMSPREE_ENDPOINT = "https://formspree.io/f/mojrjwno";

export const Waitlist = () => {
  const formRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    const form = formRef.current;
    if (!form) return;
    setLoading(true);
    try {
      const formData = new FormData(form);
      const res = await fetch(FORMSPREE_ENDPOINT, {
        method: "POST",
        headers: { Accept: "application/json" },
        body: formData,
      });
      if (res.ok) {
        setDone(true);
        form.reset();
        toast.success("Bem-vinda ao Kora Club ✦", {
          description: "Em breve você será a primeira a saber.",
        });
      } else {
        const data = await res.json().catch(() => ({}));
        const description =
          data?.errors?.[0]?.message ||
          "Não foi possível enviar agora. Tente novamente em instantes.";
        toast.error("Algo deu errado", { description });
      }
    } catch (err) {
      toast.error("Sem conexão", {
        description: "Verifique sua internet e tente novamente.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <section
      id="vip"
      data-testid="section-vip"
      className="relative bg-kora-black py-28 md:py-40 overflow-hidden"
    >
      <div className="absolute inset-0 opacity-[0.06] pointer-events-none">
        <div className="absolute -top-40 -right-40 w-[600px] h-[600px] bg-kora-gold rounded-full blur-[180px]" />
        <div className="absolute -bottom-40 -left-40 w-[600px] h-[600px] bg-kora-green rounded-full blur-[180px]" />
      </div>

      <div className="relative max-w-[1100px] mx-auto px-6 md:px-12 text-center">
        <p
          data-testid="vip-eyebrow"
          className="reveal font-mono-label text-kora-gold-light mb-6"
        >
          ✦ Lista VIP · Acesso antecipado
        </p>

        <h2
          data-testid="vip-headline"
          className="reveal reveal-delay-1 font-display text-5xl sm:text-7xl lg:text-[120px] leading-[0.98] tracking-tight text-kora-cream"
        >
          Garanta{" "}
          <span className="italic text-gold-gradient">15% off</span> na
          primeira coleção.
        </h2>

        <p
          data-testid="vip-sub"
          className="reveal reveal-delay-2 mt-8 max-w-xl mx-auto text-base md:text-lg leading-relaxed text-kora-cream/80"
        >
          Desconto exclusivo para quem entrar na lista agora. Acesso antecipado
          e peças reservadas antes de todo mundo.
        </p>

        {!done ? (
          <form
            ref={formRef}
            onSubmit={submit}
            action={FORMSPREE_ENDPOINT}
            method="POST"
            data-testid="vip-form"
            className="reveal reveal-delay-3 mt-14 w-full max-w-md mx-auto"
          >
            <div className="flex flex-col gap-3">
              <input
                type="text"
                name="name"
                data-testid="vip-input-name"
                placeholder="Seu nome (opcional)"
                className="w-full bg-kora-forest-deep border border-kora-gold/30 px-4 py-3 text-kora-cream placeholder:text-kora-cream/40 focus:outline-none focus:border-kora-gold/60 transition-colors"
              />
              <input
                type="email"
                name="email"
                required
                data-testid="vip-input-email"
                placeholder="seu@email.com"
                className="w-full bg-kora-forest-deep border border-kora-gold/30 px-4 py-3 text-kora-cream placeholder:text-kora-cream/40 focus:outline-none focus:border-kora-gold/60 transition-colors"
              />
              <button
                type="submit"
                disabled={loading}
                data-testid="vip-submit"
                className="btn-outline-hero w-full justify-center mt-2 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {loading ? "Enviando…" : "Quero entrar"}
                <ArrowRight size={14} className="arrow" />
              </button>
            </div>
            {/* Honeypot for spam protection */}
            <input
              type="text"
              name="_gotcha"
              tabIndex="-1"
              autoComplete="off"
              style={{ display: "none" }}
            />
            <p className="font-mono-label text-kora-cream/50 mt-6 text-center">
              ✦ Seu desconto será enviado antes do lançamento. Sem spam.
            </p>
          </form>
        ) : (
          <div
            data-testid="vip-success"
            className="mt-14 max-w-xl mx-auto bg-kora-forest border border-kora-gold/40 p-10"
          >
            <Check
              size={36}
              className="mx-auto text-kora-gold-light mb-4"
              strokeWidth={1.5}
            />
            <p
              data-testid="vip-success-message"
              className="font-display text-3xl md:text-4xl text-kora-cream"
            >
              Bem-vinda ao Clube.
            </p>
            <p className="text-kora-cream/75 mt-3">
              Em breve você será a primeira a saber.
            </p>
            <button
              onClick={() => setDone(false)}
              data-testid="vip-add-another"
              className="mt-8 font-mono-label text-kora-gold-light link-underline"
            >
              Cadastrar outro e-mail
            </button>
          </div>
        )}
      </div>
    </section>
  );
};
